import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Assinaturas } from '@/features/pagamentos/componentes/Assinaturas';
import { rotaDeTela } from '@/features/permissoes/guardas';

const busca = z.object({
  status: z
    .enum(['ativa', 'pendente', 'inadimplente', 'cancelada', 'encerrada'])
    .optional()
    .catch(undefined),
  cursor: z.string().optional().catch(undefined),
});

/** Assinaturas (spec 013, CA-15). */
export const Route = createFileRoute('/_autenticado/pagamentos/')({
  ...rotaDeTela('pagamentos.assinaturas'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const valores = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <Assinaturas
      busca={valores}
      aoMudarBusca={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
    />
  );
}
